<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Migrasi Data Pinjaman Debitur
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="savemigrationdata()"
            :disabled="!saveEnabled"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel">
            <i class="fa fa-close"></i> {{ $t("cancel") }}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="filterShow == 'Hide'">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="rekonsil"
                    >Rekon Status</b-form-checkbox
                  >
                  <b-form-checkbox value="uraian1"
                    >Description Sub Modul</b-form-checkbox
                  >
                  <b-form-checkbox value="uraian2"
                    >Description GL</b-form-checkbox
                  >
                  <b-form-checkbox value="nilai1"
                    >Value Sub Modul</b-form-checkbox
                  >
                  <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="table"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="data"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:thead-top="data">
            <b-tr>
              <b-th colspan="32">
                <span class="sr-only">Detail Debitur</span>
              </b-th>
              <b-th variant="primary" colspan="4" class="text-center"
                >POSISI SALDO AWAL MIGRASI</b-th
              >
            </b-tr>
          </template>

          <template v-slot:cell(tgl_kontrak)="data">
            <span v-if="data.item.tgl_kontrak">{{
              data.item.tgl_kontrak | moment("DD-MMM-YYYY")
            }}</span>
          </template>
          <template v-slot:cell(startdate)="data">
            <span v-if="data.item.startdate">{{
              data.item.startdate | moment("DD-MMM-YYYY")
            }}</span>
          </template>
          <template v-slot:cell(duedate)="data">
            <span v-if="data.item.duedate">{{
              data.item.duedate | moment("DD-MMM-YYYY")
            }}</span>
          </template>
          <template v-slot:cell(closing_date)="data">
            <span v-if="data.item.closing_date">{{
              data.item.closing_date | moment("DD-MMM-YYYY")
            }}</span>
          </template>
          <template v-slot:cell(plafon)="data">{{
            data.item.plafon | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(principal)="data">{{
            data.item.principal | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bunga_tarifthn)="data">{{
            data.item.bunga_tarifthn | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(interestod_rate_month)="data">{{
            data.item.interestod_rate_month | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(interest)="data">{{
            data.item.interest | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(saldo_interest)="data">{{
            data.item.saldo_interest | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(paym_total_amount)="data">{{
            data.item.paym_total_amount | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(saldo_principal)="data">{{
            data.item.saldo_principal | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(saldo_latecharge)="data">{{
            data.item.saldo_latecharge | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(installment_amount)="data">{{
            data.item.installment_amount | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(denda_tarifhri)="data">{{
            data.item.denda_tarifhri | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(wo_status)="data">{{data.item.wo_status?'Yes':'No'}}</template>

          <template v-slot:custom-foot>
            <b-tr>
              <b-td colspan="33">
                <h6 class="text-right">Total:</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">
                  {{ subtotal.sum_principal_outstand | numFormat("0,0.00") }}
                </h6>
              </b-td>
              <b-td>
                <h6 class="text-right">
                  {{ subtotal.sum_interest_outstand | numFormat("0,0.00") }}
                </h6>
              </b-td>
              <b-td>
                <h6 class="text-right">
                  {{ subtotal.sum_latecharge_outstand | numFormat("0,0.00") }}
                </h6>
              </b-td>
              <b-td colspan="2">&nbsp;</b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            Showing {{ (tblLcy.page - 1) * tblLcy.limit + 1 }}
            to
            <span v-if="tblLcy.page * tblLcy.limit > tblLcy.total">{{
              tblLcy.total
            }}</span>
            <span v-else>{{ tblLcy.page * tblLcy.limit }}</span>
            of {{ tblLcy.total }} entries,
          </b-col>
          <b-col cols="4">
            <div style="display: flex; margin: 0; padding: 0">
              <div
                style="
                  margin: 0;
                  padding: 5px;
                  width: 500px;
                  text-align: center;
                "
              >
                <span class="mr-1">limit per page :</span>
                <select v-model="tblLcy.limit" style="width: 60px">
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>40</option>
                  <option>50</option>
                  <option>60</option>
                  <option>70</option>
                  <option>80</option>
                  <option>90</option>
                </select>
              </div>
            </div>
          </b-col>
          <b-col lg="4">
            <div>
              <b-pagination
                class="ml-1"
                align="right"
                :total-rows="tblLcy.total"
                :per-page="tblLcy.limit"
                v-model="tblLcy.page"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <!-- <b-col cols="4">One of two columns</b-col> -->
          <b-col cols="4">
            <!-- <b-card> -->
            <b-input-group>
              <b-input-group-prepend>
                <label>Jumlah Data Error</label>
              </b-input-group-prepend>
              <span class="form-control-static py-2"
                >: {{ subtotal.error }} Record</span
              >
            </b-input-group>
            <!-- </b-card> -->
          </b-col>
        </b-row>
        <b-row v-if="showProgressMigration">
          <b-col>
            <b-alert show variant="warning"
              >Status :
              <strong v-if="progressmigrationtemp">{{
                progressmigrationtemp.status
              }}</strong>
              <!-- ,Data yang
              berhasil dibaca
              <strong>{{ progressMigrationAngsTemp.value | numFormat }}</strong>
              baris -->
            </b-alert>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="8">
        <b-card>
          <div slot="header">
            Migrasi Data Pinjaman Debitur
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>
          <div v-if="!showProgressMigration">
            <b-input-group>
              <b-input-group-prepend>
                <label>Choose *.XLSX file</label>
              </b-input-group-prepend>
              <b-form-file
                v-model="fileXlsx"
                :state="!$v.fileXlsx.$error"
                placeholder="Choose a XLSX file..."
                drop-placeholder="Drop XLSX file here..."
              ></b-form-file>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nama SHEET</label>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="frmUpload.sheetName"
                    :state="!$v.frmUpload.sheetName.$error"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="5">
                <b-input-group>
                  <b-input-group-append>
                    <label class="input-group-text ml-1"
                      >Data mulai baris ke-</label
                    >
                  </b-input-group-append>
                  <b-form-input
                    v-model="frmUpload.startRow"
                    type="number"
                    :state="!$v.frmUpload.startRow.$error"
                    style="min-width: 50px"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="12">
                <b-alert :show="showLabelError" variant="danger" class="mt-4">
                  <span v-if="labelErrorTxt != ''">{{ labelErrorTxt }}</span>
                  <b-list-group
                    flush
                    v-if="errorList && errorList.length > 0"
                    style="max-height: 280px; overflow-x: auto"
                  >
                    <b-list-group-item
                      v-for="(item, index) in errorList"
                      :key="index"
                      >Baris : {{ item.baris }}, Kolom : {{ item.kolom }} ,
                      Kesalahan : {{ item.message }}</b-list-group-item
                    >
                  </b-list-group>
                </b-alert>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <h6 class="text-center">Proses migrasi data pinjaman debitur</h6>
            <b-progress :max="100" animated>
              <b-progress-bar
                :value="progressmigration.value"
                :label="`${((progressmigration.value / 100) * 100).toFixed(
                  2
                )} %`"
              ></b-progress-bar>
            </b-progress>
          </div>
          <div slot="footer" class="text-center" v-if="!showProgressMigration">
            <b-button variant="primary" @click="importmigrationdata()"
              >Import</b-button
            >
            <b-button variant="danger" @click="close()">Close</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Konfirmasi"
      v-model="confirmCancel"
      @ok="handleCancel"
    >
      <p class="my-2">Apakah anda yakin?</p>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import klmXls from "../../data/kolomXls";
import migration from "../../apis/migration";
import uploadSet from "../../apis/uploadsetting";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
    },
    fileXlsx: { required },
  },
  data() {
    return {
      showUploadFrm: true,
      showProgressMigration: false,
      fileXlsx: null,
      frmUpload: {
        sheetName: "PINJAMAN DEBITUR",
        startRow: 9,
        no: "A",
        compcode: "B",
        no_kontrak: "C",
        no_agreement: "D",
        tgl_kontrak: "E",
        uraian: "F",
        startdate: "G",
        duedate: "H",
        principal: "I",
        matauang: "J",
        tenor: "K",
        bunga_tarifthn: "L",
        installment_amount: "M",
        denda_tarifhri: "N",
        model_pinjaman: "O",
        bungaod_tarifbln: "P",
        CustName: "Q",
        CustCode: "R", //CIF
        nomoridentitas: "S",
        alamatktp: "T",
        kelurahanktp: "U",
        kecamatanktp: "V",
        kotaktp: "W",
        provinsiktp: "X",
        kodeposktp: "Y",
        alamat: "Z",
        kelurahan: "AA",
        kecamatan: "AB",
        kota: "AC",
        provinsi: "AD",
        kodepos: "AE",
        closing_date: "AF",
        saldo_principal: "AG",
        saldo_interest: "AH",
        saldo_latecharge: "AI",
        collectability: "AJ",
        paym_install_no: "AK",
        wo_status:'AL',
        cessie_os:'AM',
        cessie_date:'AN',
        cessie_collectability:'AO',
        project_cassie:'AR'
      },
      showLabelError: false,
      errorList: [],
      labelErrorTxt: "",
      kolomXls: klmXls,
      isLoading: false,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      subtotal: {
        sum_paym_total_amount: 0,
        sum_principal_outstand: 0,
        sum_interest_outstand: 0,
        sum_denda_tarifhri: 0,
      },

      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "no",
            label: "No.",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "compcode",
            label: "Kode Entitas",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "no_kontrak",
            label: "No. Kontrak",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "no_agreement",
            label: "No. Agreement",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "tgl_kontrak",
            label: "Tgl. Kontrak",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Uraian",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "startdate",
            label: "Startdate",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "duedate",
            label: "Duedate",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          // {
          //   key: "plafon",
          //   label: "Plafon",
          //   thClass: "text-center",
          //   tdClass: "text-right",
          //   sortable: true,
          // },
          {
            key: "principal",
            label: "Principal",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "matauang",
            label: "Mata Uang",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "tenor",
            label: "Tenor (Bulan)",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "bunga_tarifthn",
            label: "Interest (%)",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "installment_amount",
            label: "Installment",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },

          {
            key: "paym_install_no",
            label: "No Installment Paid",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "denda_tarifhri",
            label: "Tarif Denda (%)",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "model_pinjaman",
            label: "Model Pinjaman",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "interestod_rate_month",
            label: "Interest OD PRK (%)",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "CustName",
            label: "Nama Debitur",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "CustCode",
            label: "CIF",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nomoridentitas",
            label: "Nomor Identitas",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "alamatktp",
            label: "Alamat KTP",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kelurahanktp",
            label: "Kelurahan KTP",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kecamatanktp",
            label: "Kecamatan KTP",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kotaktp",
            label: "Kota KTP",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "provinsiktp",
            label: "Provinsi KTP",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kodeposktp",
            label: "Kodepos KTP",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "alamat",
            label: "Alamat",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kelurahan",
            label: "Kelurahan",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kecamatan",
            label: "Kecamatan",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kota",
            label: "Kota",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "provinsi",
            label: "Provinsi",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "kodepos",
            label: "Kodepos",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "closing_date",
            label: "Closing Date",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "saldo_principal",
            label: "Principal Outstand",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "saldo_interest",
            label: "Interest Outstand",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "saldo_latecharge",
            label: "Latecharge Outstand",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },

          {
            key: "collectability",
            label: "Collectability",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "wo_status",
            label: "WO",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
        ],
      },
      filter: null,
      filterOn: [],
      groupmigrationpinjamankey: null,
      confirmCancel: false,
      saveEnabled: false,
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
    invalidFileXlsx() {
      this.$v.fileXlsx.$touch();
      return this.$v.fileXlsx.$invalid;
    },
    progressmigrationtemp() {
      return this.$store.state.progressMigrationPinjTemp;
    },
    progressmigration() {
      return this.$store.state.progressMigrationPinj;
    },
  },
  watch: {
    progressmigrationtemp(val) {
      if (val.status == "Idle") {
        this.showProgressMigration = false;
      }

      if (val.status == "Running") {
        this.showProgressMigration = true;
      }

      if (val.status == "Finish") {
        this.showProgressMigration = false;
        this.saveEnabled = true;
        toastr.success("Data selesai dibaca", "", 10000);
      }
      if (this.$refs.table) {
        this.$refs.table.refresh();
      }
    },
    progressmigration(val) {
      if (val) {
        if (val.status == "Idle") {
          this.showProgressMigration = false;
        }

        if (val.status == "Running") {
          this.showProgressMigration = true;
        }

        if (val.status == "Finish") {
          this.showProgressMigration = false;
          toastr.success("Migrasi data telah berhasil", "", 10000);
          this.handleCancel();
        }
      }
    },
  },
  created: async function () {
    let getgroupmigrationkey = localStorage.getItem(
      "groupmigrationpinjamankey"
    );
    if (getgroupmigrationkey) {
      this.showUploadFrm = false;
      this.saveEnabled = true;
      // let res = await migration.getmigrationTEMP(
      //   getgroupmigrationkey,
      //   getSheetName
      // );
      // // jika tidak ada data balikan dari DB maka storage dihapus
      // if(res.length==0){
      //   this.showUploadFrm = true;
      //   localStorage.removeItem("groupmigrationkey");
      //   localStorage.removeItem("sheetName");
      // }
      // this.rptLines = res;
      // this.sum(res);
    }

    // Get setting field from DB
    const setting = await uploadSet.get("upload_migrationpinjaman");
    for (const key in setting) {
      // compcode= "murni"
      // compcode
      this.frmUpload[key] = setting[key];
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    async data() {
      this.isLoading = true;
      let getgroupmigrationkey = localStorage.getItem(
        "groupmigrationpinjamankey"
      );
      let getSheetName = "PINJAMAN_DEBITUR";
      if (getgroupmigrationkey) {
        this.showUploadFrm = false;
        // this.saveEnabled = this.progressmigrationtemp && (this.progressmigrationtemp.status == "Finish" || this.progressmigrationtemp.status == "Idle")?true:false;
        this.tblLcy.groupmigrationkey = getgroupmigrationkey;
        this.tblLcy.sheetName = getSheetName;
        this.tblLcy.sortDir = this.tblLcy.sortDesc ? "desc" : "asc";
        let { list, count } = await migration.getmigrationTEMP(this.tblLcy);
        if (list.length == 0) {
          this.showUploadFrm = true;
          // localStorage.removeItem("groupmigrationkey");
        }
        const subtotal = {};
        for (const key in count) {
          subtotal[key] = count[key];
        }
        this.subtotal = subtotal;
        this.isLoading = false;
        return list;
      }
    },
    async importmigrationdata() {
      if (this.invalidFileXlsx || this.invalidFrmUpload) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.showLabelError = false;
          this.isLoading = true;
          const {
            list: result,
            groupmigrationkey,
          } = await migration.savemigrationpinjamanTEMP(
            this.fileXlsx,
            this.frmUpload
          );
          // if (result.length == 0) {
          //   toastr.warn("Data is empty");
          // } else {
          this.saveEnabled = result.filter((x) => x.error == true).length == 0;
          this.groupmigrationpinjamankey = groupmigrationkey;
          localStorage.setItem("groupmigrationpinjamankey", groupmigrationkey);
          // }
          toastr.success("Background Service Data Migration Started");
          const this_ = this;
          setTimeout(function () {
            this_.isLoading = false;
            this_.showUploadFrm = false;
            this_.showProgressMigration = true;
            this_.saveEnabled = false;
          }, 1000);
        } catch (error) {
          this.isLoading = false;
          if (error.errSheetList || error.message) {
            this.showLabelError = true;
            this.labelErrorTxt = error.message;
            this.errorList = error.errSheetList;
            this.fileXlsx = null;
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },

    async savemigrationdata() {
      if (this.tblLcy.total == 0) {
        toastr.warn("Data is empty");
      } else {
        try {
          this.isLoading = true;
          let groupmigrationkey = localStorage.getItem(
            "groupmigrationpinjamankey"
          );
          await migration.savemigrationpinjaman(groupmigrationkey);
          this.showUploadFrm = true;
          // localStorage.removeItem("groupmigrationpinjamankey");
          // toastr.success("Data migrasi berhasil disimpan.");
          toastr.success("Background Service Data Migration Started");
          this.showProgressMigration = true;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
    cancel() {
      if (!this.saveEnabled) {
        this.handleCancel();
      } else {
        this.confirmCancel = !this.confirmCancel;
      }
    },
    async handleCancel() {
      this.showUploadFrm = true;
      this.rptLines = [];
      await migration.removeDataTEMP({
        tablename: "fin_migration_pinjaman_debitur",
        groupmigrationkey: localStorage.getItem("groupmigrationpinjamankey"),
      });
      localStorage.removeItem("groupmigrationpinjamankey");
    },
  },
};
</script>
